// extracted by mini-css-extract-plugin
module.exports = {"logo-element":"LogoCard_logo-element__bwuvA","has-border-radius":"LogoCard_has-border-radius__BLb0z","has-box-shadow":"LogoCard_has-box-shadow__JkNwX"};